<template>
  <div class="app-container">
    <ActivateLowLevelStep :desc="$t('step_2_title')" health="50" />

    <div class="step-content step-content-from">
      <OcrFrom ref="ocr" class="mb60" />
      <AddressFrom ref="address" />
      <md-button class="mt60" type="primary" @click="validateBeforeSubmit">
        {{ $t("submit_btn") }}
      </md-button>
    </div>

    <PayLoading :context="$t('waitingText')" :is-show="showLoading" />
  </div>
</template>

<script>
import ActivateLowLevelStep from '@/components/ActivateLowLevelStepBar'
import OcrFrom from './components/OcrFrom'
import AddressFrom from './components/AddressFrom'
import PayLoading from '@/components/PayLoading'
import { Button } from 'mand-mobile'
import { saveConfirmInfo } from '@/api/activateLowLevelStep'

// 提交用户身份信息
export default {
  name: 'ActivateLowLevelStep2',

  components: {
    ActivateLowLevelStep,
    OcrFrom,
    AddressFrom,
    PayLoading,
    [Button.name]: Button
  },

  data () {
    return {
      showLoading: false
    }
  },

  methods: {
    // 表单提交
    async validateBeforeSubmit () {
      try {
        const [ocrFrom, addressFrom] = await Promise.all([
          this.$refs.ocr.validate(),
          this.$refs.address.validate()
        ]) // 校验表单以及获取表单数据
        this.showLoading = true
        await saveConfirmInfo({
          ...ocrFrom,
          ...addressFrom,
          certificateType: 1
        }) // 保存表单内容接口
        this.$router.replace({ name: 'ActivateLowLevelStep3' })
      } finally {
        this.showLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.step-content {
  margin-top: 84px;
}

/* stylelint-disable selector-pseudo-element-no-unknown, no-duplicate-selectors */
.step-content-from {
  ::v-deep .flash-block_body {
    padding: 36px 44px;

    .md-field {
      padding: 0;
    }
  }
}
/* stylelint-enable */
</style>
